function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m44.603 24.389.269.004c4.992.142 9.035 4.25 9.035 9.246v13.028H35.3V33.639c0-5.086 4.188-9.25 9.303-9.25zm.12-21.722c5.105 0 9.243 4.114 9.243 9.19s-4.138 9.191-9.243 9.191-9.244-4.115-9.244-9.19c0-5.077 4.139-9.191 9.244-9.191z",
  fill: "#2175D9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.633 55.925c0-2.976-2.707-5.409-6-5.409H47.248c.143 1.774-.416 3.534-1.705 4.822-2.463 2.461-6.645 2.26-9.323-.415L25.093 43.806a.863.863 0 0 1 0-1.23.865.865 0 0 1 1.232 0l11.127 11.117c2.005 2.003 5.098 2.189 6.874.415 1.776-1.775 1.59-4.85-.415-6.868L25.179 28.567c-1.804-1.803-3.494-1.702-5.485-1.702l-17.844.014a1.21 1.21 0 0 0-1.203 1.202L.633 45.737c0 .658.544 1.202 1.189 1.188 0 0 7.69-.014 8.535-.014.83 0 1.146-.043 2.205 1.015L24.42 59.774c.072.071.158.129.23.186 1.059.858 2.462 1.373 3.995 1.373l29.945-.014c3.336.014 6.043-2.418 6.043-5.394z",
  fill: "#FFB511"
}));
function SvgTypeHrCustomer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeHrCustomer);
export default __webpack_public_path__ + "static/media/TypeHRCustomer.b7b3150fb4238b08e6cfe881dad1c58f.svg";
export { ForwardRef as ReactComponent };